import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { offerRequestModel } from "../api/models/CreateOfferModel";

class CreateOfferApi {
    private authClient: AuthClient;

    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async createOffer(offer: offerRequestModel) {

        try {
            const authenticationResponse = this.authClient.getAuthenticationResponse();
            if (authenticationResponse === undefined) {
                return;
            }

            const response = await axios.post(
                `${this.authClient.getApiRoot()}/offers`,
                offer,
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
            };

        } catch (error) {
            const axiosError = error as AxiosError;

            if (axiosError.response) {
                const { status, data } = axiosError.response;

                switch (status) {
                    case 400:
                        console.error("Bad Request Error (400)", data);
                        break;
                    case 401:
                        console.error("Unauthorized Error (401)", data);
                        break;
                    case 404:
                        console.error("Not Found URL (404)", data);
                        break;
                    case 500:
                        console.error("Internal server Error (500)", data);
                        break;
                    default:
                        console.error("Unhandled Error", data);
                        break;
                }

                return {
                    statusCode: status,
                    errorMessage: axiosError.message as string,
                    data: undefined
                };
            }
        }
    }
}

export default CreateOfferApi;
